export const STORAGE_KEYS = {
  SUPPLIER_DETAILS: 'supplierDetails',
  GAMMA_ORDER_RESPONSE: 'gammaOrderResponse',
} as const;
